export const START_DWELL_TYPE = "start";
export const END_DWELL_TYPE = "end";

export const DWELL_TIME_UNIT_DAYS = "d";
export const DWELL_TIME_UNIT_HOURS = "h";
export const DWELL_TIME_UNIT_MINUTES = "m";